import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import App from './App.vue'
import LoginView from './views/LoginView.vue'
import DashboardView from './views/DashboardView.vue'
import UsersView from './views/UsersView.vue'
import QuotasView from './views/QuotasView.vue'
import BrandView from './views/BrandView.vue'
import CasesView from './views/CasesView.vue'
import './styles.css'

const routes = [
  { path: '/login', component: LoginView, meta: { public: true } },
  { path: '/', component: DashboardView }, { path: '/users', component: UsersView },
  { path: '/quotas', component: QuotasView }, { path: '/brand', component: BrandView },
  { path: '/cases', component: CasesView }
]
const router = createRouter({ history: createWebHistory(), routes })
router.beforeEach((to) => { if (!to.meta.public && !localStorage.getItem('adminToken')) return '/login'; if (to.path === '/login' && localStorage.getItem('adminToken')) return '/' })
createApp(App).use(router).mount('#app')
